import { Directive, inject } from '@angular/core';
import { AlertDialog } from './alert-dialog';

@Directive({
  selector: '[alertDialogAction]',
  host: {
    '(click)': 'close()',
  },
})
export class AlertDialogAction {
  // Dependencies
  private alertDialog = inject(AlertDialog);

  close() {
    this.alertDialog.open.set(false);
  }
}
